import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef, KalSelectionModel } from '@kalidea/kaligraphi';
import { DevisCommandeListingModel } from 'src/graphql/generated-types';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/classes/kal-table-header';

export interface SharedInvoicesOrdersListDialogData {
    ordersList: DevisCommandeListingModel[];
    selectedOrderId: number;
    accepted: boolean;
}

@Component({
    selector: 'app-shared-contacted-beneficiaries-dialog',
    templateUrl: './shared-invoices-orders-list-dialog.component.html',
    styleUrls: ['./shared-invoices-orders-list-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedInvoicesOrdersListDialogComponent<T extends DevisCommandeListingModel> extends BaseComponent implements OnInit {

    selection = new KalSelectionModel<T>();

    columns: KalTableHeader<T>[] = [
        {code: 'DateCommande', label: 'Date'},
        {code: 'IdCommande', label: 'N° de commande'},
        {code: 'NomFournisseur', label: 'Fournisseur'},
        {code: 'LibelleCommande', label: 'Objet'},
        {code: 'MontantTotalCommande', label: 'Montant total'},
    ];

    constructor(private readonly dialogRef: KalDialogRef<SharedInvoicesOrdersListDialogComponent<T>>,
                protected readonly cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public data: SharedInvoicesOrdersListDialogData) {
        super(cdr);
    }

    get ordersList(): T[] {
        return this.data.ordersList as T[];
    }

    get hasNotSelectedOrder(): boolean {
        return this.selection.isEmpty();
    }

    close(): void {
        this.dialogRef.close();
    }

    submit(): void {
        if (this.hasNotSelectedOrder) {
            return;
        }

        this.data.selectedOrderId = this.selection.added[0].IdCommande;
        this.data.accepted = true;

        this.dialogRef.close(this.data);
    }

    ngOnInit(): void {
    }

}
